import { getApiUrl } from "../../constants/pathConstants"
import { API_END_POINT_COMPLETE_TIP, API_END_POINT_COMPLETE_TRANSACTION, API_END_POINT_UPDATE_INTERACTION_STATUS } from "../endPoints"
import { CompleteTransactionResponse } from "../types"

class TransactionConnector {
	requestInProgress: boolean = false

	public async updateInteractionStatusRequest(id: string, status: string | undefined, instructorId: string): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [InteractionConntor] updateInteractionRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true
				let requestSuccess = false

				await fetch(`${getApiUrl()}${API_END_POINT_UPDATE_INTERACTION_STATUS}`,{
					method: 'post',
					headers: {'Content-Type':'application/json'},
					body: JSON.stringify({
						"id": id,
						"status": status,
						"instructorId": instructorId
					})
				})
					.then((res) => res.json())
					.then((data) => {
						if (data.status === 'success') {
							requestSuccess = true
						} else {
							requestSuccess = false
						}
					})
					.catch((error) => {
						console.log(error)
					})
				
				this.requestInProgress = false
				return requestSuccess
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[InteractionConntor] - updateInteractionRequest() failed')
			console.log(err)
			return false
		}
	}

	public async completeTransactionRequest(transactionId: string, status: string, isTip: boolean = false): Promise<boolean> {
		console.log('isTip', isTip)
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [TransactionConnector] conpleteTransactionRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true
				let requestSuccess = false

				// await fetch(`${getApiUrl()}complete-transaction`,{
				await fetch(isTip ? `${getApiUrl()}${API_END_POINT_COMPLETE_TIP}` : `${getApiUrl()}${API_END_POINT_COMPLETE_TRANSACTION}`,{
					method: 'post',
					headers: {'Content-Type':'application/json'},
					body: JSON.stringify({
						"id": transactionId,
						"status": status === 'success' ? isTip ? 'PAYMENT_COMPLETE' : 'ACTIVE' : 'PAYMENT_FAILED'
					})
				})
					.then((res) => res.json())
					.then((data) => {
						if (data.status === 'success') {
							requestSuccess = true
						} else {
							requestSuccess = false
						}
					})
					.catch((error) => {
						console.log(error)
					})
				
				this.requestInProgress = false
				return requestSuccess
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[TransactionConnector] - performRegisterRequest() failed')
			console.log(err)
			return false
		}
	}
}

export const transactionConnector: TransactionConnector = new TransactionConnector()